<div class="tabsWithOverlay">
    @if (showInitialBootstrapOverlay()) {
        <app-loading-spinner [placeholder]="'Loading report...'" [isOverlay]="true" />
    }
    <lib-tab-view
        [currentTab]="service.currentTab()"
        (currentTabChange)="service.currentTab.set($event)"
        alignment="start"
        [renderAll]="true"
    >
        <lib-tab-item tabName="Overview" [disabled]="!service.initialBootstrapComplete()" [bodyTemplate]="overviewTab">
            <ng-template #overviewTab>
                <div class="tab overview-tab">
                    <app-overview-tab />
                </div>
            </ng-template>
        </lib-tab-item>
        <lib-tab-item tabName="Grid View" [disabled]="!service.initialBootstrapComplete()" [bodyTemplate]="gridTab">
            <ng-template #gridTab>
                <div class="tab grid-tab">
                    <app-grid-tab />
                </div>
            </ng-template>
        </lib-tab-item>
    </lib-tab-view>
</div>
